module.exports = __webpack_public_path__ + "img/kommune-706.1bd280b6.svg";